module.exports = __webpack_public_path__ + "static/Nanopesos0-b3a0fb3707010333da1d13649eb4156c.png";